<template>
  <div>
    <report-tabs :tabs="tabs" :options="processedOptions">
      <template slot="settings">
        <div class="mx-3">
          <cool-label>Date Range</cool-label>
          <date-picker :date="options.date"></date-picker>
        </div>
        <div v-if="auth.company().bidder || (auth.company().exchange && auth.company().publisher)" class="mx-3">
          <cool-label>Select Network</cool-label>
          <populating-filter-dropdown field="exchange" v-model="options.filter.value" :date="options.date"
                                      placeholder="Select exchange"></populating-filter-dropdown>
        </div>
        <div v-if="auth.company().exchange" class="mx-3">
          <cool-label>Select Publisher</cool-label>
          <populating-filter-dropdown field="pub_name" v-model="options.filter.value" :date="options.date"
                                      placeholder="Select publisher"></populating-filter-dropdown>
        </div>
      </template>
    </report-tabs>
  </div>
</template>

<script>
    import ReportTabs from '@/reports/components/ReportTabs'
    import DatePicker from '@/components/DatePicker'
    import PopulatingFilterDropdown from '@/reports/components/PopulatingFilterDropdown'
    import MultiStatFieldView from '@/reports/components/MultiStatFieldView'
    import auth from '@/auth'

    import moment from 'moment'

    export default {
        props: {
            cid: {type: String, required: false}
        },
        data() {
            return {
                auth: auth,
                //options is the options that the user sets in the top bar
                //it should never be used to actually pull a report
                options: {
                    date: {
                        start: moment().utc().startOf('day').valueOf(),
                        end: moment().utc().startOf('day').valueOf(),
                        interval: 'HOUR'
                    },
                    stats: this.modeStats(),
                    filter: {
                        field: '',
                        operator: 'EQUAL',
                        value: ''
                    },
                    dateAsMillis: true,
                    filters: [],
                },
                currentTab: 0,
                perPage: 10,
            }
        },
        methods: {
            modeStats() {
                let st = ['bids', 'clears', 'fill_rate']
                if(auth.isAdmin()) {
                    st.push('cost')
                    st.push('spend')
                    st.push('avg_spend_cpm')
                    return st
                }

                let mode = this.mode()
                if(mode === 'publisher' || mode === 'exchange') {
                    st.push('cost')
                    st.push('avg_cost_cpm')
                } else if(mode === 'demand') {
                    st.push('spend')
                    st.push('avg_spend_cpm')
                }

                return st
            },
            mode() {
                return this.$route.path.split("/")[1]
            }
        },
        computed: {
            tabs() {
                let tabs = []
                let mode = this.mode()
                tabs.push({
                  tabName: 'Welcome',
                  component: MultiStatFieldView,
                  field: ''
                })
                tabs.push({
                    tabName: 'Overview',
                    component: MultiStatFieldView,
                    field: 'date'
                })
                if (mode === 'demand') {
                    tabs.push({
                        tabName: 'Endpoint',
                        component: MultiStatFieldView,
                        field: 'endpoint'
                    })
                }
                if (mode === 'demand' || mode === 'admin') {
                    tabs.push({
                        tabName: 'Exchange',
                        component: MultiStatFieldView,
                        field: 'exchange_name'
                    })
                }
                if (mode === 'exchange' || mode === 'publisher' || mode === 'admin') {
                    tabs.push({
                        tabName: 'Bidders',
                        component: MultiStatFieldView,
                        field: 'bidder_name'
                    })
                }
                if (mode === 'publisher' || mode === 'admin') {
                    tabs.push({
                        tabName: 'Mediums',
                        component: MultiStatFieldView,
                        field: 'med_name'
                    })
                }
                if (mode === 'exchange' || mode === 'admin') {
                    tabs.push({
                        tabName: 'Publishers',
                        component: MultiStatFieldView,
                        field: 'pub_name'
                    })
                }
                tabs.push({
                    tabName: 'Country',
                    component: MultiStatFieldView,
                    field: 'geo_country'
                })
                tabs.push({
                    tabName: 'Platform',
                    component: MultiStatFieldView,
                    field: 'dev_os'
                })
                tabs.push({
                    tabName: 'App/Site',
                    component: MultiStatFieldView,
                    field: 'med_type'
                })
                tabs.push({
                    tabName: 'Ad Formats',
                    component: MultiStatFieldView,
                    field: 'ad_formats'
                })
                tabs.push({
                    tabName: 'Ad Dimensions',
                    component: MultiStatFieldView,
                    field: 'dims'
                })

                return tabs
            },
            processedOptions() {
                let options = Object.assign({}, this.options)
                options.startTime = options.date.start
                options.endTime = options.date.end
                options.interval = options.date.interval
                delete options.date

                if (options.filter.value.length > 0) {
                    options.filters.push(options.filter)
                }
                delete options.filter

                let mode = this.mode()
                if (mode === 'publisher') {
                    options.filters.push({field: 'pub_id', operator: 'EQUAL', value: this.cid})
                }
                if (mode === 'demand') {
                    options.filters.push({field: 'bidder_id', operator: 'EQUAL', value: this.cid})
                }
                if (mode === 'exchange') {
                    options.filters.push({field: 'exchange_id', operator: 'EQUAL', value: this.cid})
                }

                return options
            },
        },
        components: {
            ReportTabs,
            DatePicker,
            PopulatingFilterDropdown
        }
    }
</script>



// WEBPACK FOOTER //
// src/reports/pages/Activity.vue